import React, { Suspense, useContext } from 'react'
import VisionFrameworkPortal from '../utility-components/VisionFrameworkPortal';
import { UserContext } from '../contexts/UserContext';


function VisionFramework() {
    const { user } = useContext(UserContext);
    const emptyLoading = () => <div></div>;

    return (<>
        {!!user && <Suspense fallback={emptyLoading()}>
            <VisionFrameworkPortal
                isCondensed={false}
            />
        </Suspense>}
    </>

    )
}

export default VisionFramework;